import { Route } from '@angular/router';
import { FeatureFlagGuard } from 'app/core';
import { FeatureFlag } from 'app/core/enums/feature-flag';
import { AutomationsSettingsComponent } from './automations.component';
import { AutomationsSettingsListComponent } from './list/list.component';
import { ProjectDataResolver, ProjectsFieldDefsResolver } from 'app/modules/projects/projects.resolvers';
import { BuilderComponent } from './builder/builder.component';
import { StoreResolver } from './automations.resolvers';

export const automationsRoutes: Route[] = [
  {
    path: '',
    component: AutomationsSettingsComponent,
    resolve: {
      fieldDefs: ProjectsFieldDefsResolver,
      options: ProjectDataResolver,
    },
    children: [
      {
        path: '',
        component: AutomationsSettingsListComponent,
        canActivate: [FeatureFlagGuard],
        data: { featureFlag: FeatureFlag.AUTOMATIONS, redirectPath: 'settings/general' },
        resolve: {
          fieldDefs: ProjectsFieldDefsResolver,
          options: ProjectDataResolver,
        },
      },
      {
        path: 'builder',
        runGuardsAndResolvers: 'always',
        resolve: { store: StoreResolver },
        component: BuilderComponent,
      },
      {
        path: 'builder/:id',
        runGuardsAndResolvers: 'always',
        resolve: { store: StoreResolver },
        component: BuilderComponent,
      },
    ],
  },
];
